import { AbstractMethodError } from "@awayjs/core";
/**
 * @class away.partition.NodeBase
 */
var NodeBase = /** @class */ (function () {
    function NodeBase(entity, partition) {
        this._childNodes = new Array();
        this._numChildNodes = 0;
        this._entity = entity;
        this._partition = partition;
    }
    Object.defineProperty(NodeBase.prototype, "entity", {
        get: function () {
            return this._entity;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(NodeBase.prototype, "pickObject", {
        get: function () {
            return this._entity.pickObject;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(NodeBase.prototype, "boundsVisible", {
        get: function () {
            return false;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(NodeBase.prototype, "maskId", {
        /**
         *
         * @returns {number}
         */
        get: function () {
            return this._entity.maskId;
        },
        enumerable: true,
        configurable: true
    });
    NodeBase.prototype.getBoundsPrimitive = function (pickGroup) {
        throw new AbstractMethodError();
    };
    /**
     *
     * @param planes
     * @param numPlanes
     * @returns {boolean}
     * @internal
     */
    NodeBase.prototype.isInFrustum = function (rootEntity, planes, numPlanes, pickGroup) {
        if (!this._entity._iIsVisible())
            return false;
        return true;
        return this._partition.isUpdated || pickGroup.getBoundsPicker(this._partition)._isInFrustumInternal(rootEntity, planes, numPlanes);
    };
    NodeBase.prototype.isVisible = function () {
        return this._entity._iIsVisible();
    };
    /**
     *
     * @param rayPosition
     * @param rayDirection
     * @returns {boolean}
     */
    NodeBase.prototype.isIntersectingRay = function (rootEntity, rayPosition, rayDirection, pickGroup) {
        return true;
    };
    /**
     *
     * @returns {boolean}
     */
    NodeBase.prototype.isRenderable = function () {
        return true;
    };
    /**
     *
     * @returns {boolean}
     */
    NodeBase.prototype.isCastingShadow = function () {
        return true;
    };
    NodeBase.prototype.dispose = function () {
        this.parent = null;
        this._childNodes = null;
    };
    /**
     *
     * @param traverser
     */
    NodeBase.prototype.acceptTraverser = function (traverser) {
        if (this._partition.root == this._entity)
            this._partition.updateEntities();
        //get the sub-traverser for the partition, if different, terminate this traversal
        if (traverser.partition != this._partition && traverser != traverser.getTraverser(this._partition))
            return;
        if (traverser.enterNode(this)) {
            for (var i = 0; i < this._numChildNodes; i++)
                this._childNodes[i].acceptTraverser(traverser);
        }
    };
    /**
     *
     * @param node
     * @internal
     */
    NodeBase.prototype.iAddNode = function (node) {
        node.parent = this;
        this._childNodes[this._numChildNodes++] = node;
    };
    /**
     *
     * @param node
     * @internal
     */
    NodeBase.prototype.iRemoveNode = function (node) {
        var index = this._childNodes.indexOf(node);
        this._childNodes[index] = this._childNodes[--this._numChildNodes];
        this._childNodes.pop();
    };
    return NodeBase;
}());
export { NodeBase };
